import React from "react";
import { authorizationService } from "shared-auth";

export default function withOidcAuthContext<P>(
  WrappedComponent:
    | React.ComponentClass<P>
    | React.FC<React.PropsWithChildren<P>>
): typeof React.Component {
  return class extends React.Component<P> {
    public async UNSAFE_componentWillMount() {
      await authorizationService.getUser();
    }

    public render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
